import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

const About = dynamic(() => import('ui/pages/About'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/about">
      <About/>
    </PageNextJs>
  );
};

export default Page;
